import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexRow)`
    padding: 24px;
    border-radius: 6px;
    justify-content: space-between;
    background-color: ${colorsPalettes.blue[100]};
    gap: 24px;
    margin-bottom: 24px;
`;
export const LeftContainer = styled(FlexColumn)`
    gap: 24px;
`;
export const DomainCompareContainer = styled(FlexRow)`
    justify-content: flex-start;
`;
